import AgentRole from './AgentRole';

export default AgentRole;
